
import { deleteAppointmentType, getAppointmentTypeList, getMasterData } from './actions/AppointmentTypeActions';
import React, { Component } from 'react';
import {
  renderTextField,
} from './../../../../components/reduxFields';
import AppointmentTypeModal from './appointment_type_modal';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import PaginatorCustom from './../../../../components/paginationCustom';
import SubString from 'add-ellipsis';
import SortingCustom from '../../../../components/SortingCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { resetFiltersAndSorting, alertConfirmation } from '../../../../actions/utilAction';
import Tooltip from '../../../../components/Tooltip';

class ManageAppointmentType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      appointmentTypeId: null,
      appointmentTypeObj: null,
    };

    this.filter = {
      sort_Column: 'name',
      sort_order: 'asc',
      searchText: '',
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.renderActivities = this.renderActivities.bind(this);
    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }

  componentWillMount() {
    this.loadData();
    const masterData = { masterdata: 'MASTERTHERAPY,MASTERNOTETYPE,PAYRATETYPE,MASTERROLES,MASTERAPPOINTMENTTYPEDEFAULTSETTING' };
    this.props.getMasterData(masterData);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.deleted_AppointmentType && nextProps.deleted_AppointmentType !== this.props.deleted_AppointmentType) {
      this.loadData();
    }
    if (nextProps.saved_appointmentType && nextProps.saved_appointmentType !== this.props.saved_appointmentType) {
      this.loadData();
    }


  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getAppointmentTypeList(searchObj);
  }


  handleOpen() {
    Alert.closeAll();
    this.setState({ open: true, appointmentTypeId: null, appointmentTypeObj: null });
  }
  handleClose() {
    this.setState({ open: false });
  };

  handleEditClick = (e, obj) => {
    Alert.closeAll();
    this.setState({
      open: true,
      appointmentTypeId: obj.id,
      appointmentTypeObj: obj,
    });
  };

  handleAlertClick = (event, apptTypeId) => {
    Alert.closeAll();
    this.props.deleteAppointmentType(apptTypeId);
  };

  handleDeleteClick = (e, obj) => {
    let warningMsg = `<strong>${obj.name}</strong> may be assigned to the payer.<br/>Are you sure you want to delete this appointment type?`;
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  setSortColumn(col_name, col_order) {
    this.filter.sort_Column = col_name;
    this.filter.sort_order = col_name == 'name' ? col_order === 'asc'?'desc' :'asc' : col_order;
    this.loadData();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ManageAppointmentTypeform'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.loadData();
  }

  handleSubmitSearch() {
    return false;
  }

  renderActivities = (appointmentTypeList) => {
    appointmentTypeList = appointmentTypeList || [];

    if (!appointmentTypeList.length) {
      return (
        <tr><td colSpan="6" className="text-center no-record">No record found.</td></tr>
      );
    }
    return appointmentTypeList.map((data, index) => {
      return (
        <tr key={index}>
          <td width="25%">{data.name}</td>
          <td width="35%">
            {data.description && data.description.length > 0 ?
              <Tooltip Description = {data.description} />
              : null}
            {data.description && data.description.length > 35 ? SubString(data.description, 35) : data.description ? data.description : '-'}
          </td>
          <td width="10%" className={data.isBillable === true ? 'greenfont' : 'redfont'}>{data.isBillable === true ? 'Yes' : 'No'}</td>
          <td width="10%"><span className="bgcolor-circle" style={{ backgroundColor: data.color }}></span></td>
          <td width="10%"><span className="bgcolor-circle" style={{ backgroundColor: data.fontColor }}></span></td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td width="10%">
              {data.name.toLowerCase() !== "drive time" && data.name.toLowerCase() !== "paid 10 minute break" && this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, data)} title="Edit" type="button" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {data.name.toLowerCase() !== "drive time" && data.name.toLowerCase() !== "paid 10 minute break" &&  this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, data)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  };

  render() {
    const { handleSubmit, appointmentTypeListData } = this.props,
      appointmentTypeList = (appointmentTypeListData && appointmentTypeListData.data) || [],
      appointmentTypeMeta = (appointmentTypeListData && appointmentTypeListData.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        {this.state.open ?
          <AppointmentTypeModal
            open={this.state.open}
            closeDialog={this.handleClose}
            appointmentTypeId={this.state.appointmentTypeId}
            appointmentTypeObj={this.state.appointmentTypeObj}
          /> : ''}
        <h2 className="page_title">Manage Appointment Type</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="row">
              <div className="col-sm-5">
                {this.props.addPermission ?
                  <RaisedButton label="Add Appointment Type" primary={true} onTouchTap={this.handleOpen} />
                  : null
                }
              </div>
              <div className="col-sm-7">
                <div className="row end-flex">
                  <div className="col-sm-6 mtm-27">
                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)}>
                      <Field
                        name="Name"
                        floatingLabelText="Search"
                        maxLength="99"
                        onChange={this.handleSearchChange}
                        component={renderTextField}
                        fullWidth={true}
                      />
                    </form>
                  </div>
                  <div className="reset-btn col-sm-3 btn_rt">
                    <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton} >Reset</RaisedButton>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive mt-15">
              <table className={tableClass}>
                <thead>
                  <tr>
                    <th width="25%">
                      {<SortingCustom noSort={!appointmentTypeList.length} setSortColumn={this.setSortColumn} columnName='name' displayName='Name' />}
                    </th>
                    <th width="35%">
                      {<SortingCustom noSort={!appointmentTypeList.length} setSortColumn={this.setSortColumn} columnName='description' displayName='Description' />}
                    </th>
                    <th width="10%">
                      {<SortingCustom noSort={!appointmentTypeList.length} setSortColumn={this.setSortColumn} columnName='isBillAble' displayName='Billable' />}
                    </th>
                    <th width="10%">Color</th>
                    <th width="10%">Font Color</th>
                    {this.props.updatePermission || this.props.deletePermission ?
                      <th width="10%">Actions</th>
                      : null
                    }
                  </tr>
                </thead>
                <tbody>
                  {this.renderActivities(appointmentTypeList)}
                </tbody>
              </table>
            </div>
            {appointmentTypeMeta && appointmentTypeMeta['totalPages'] ?
              <PaginatorCustom data={appointmentTypeMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
              : null
            }
          </div>
        </div>
      </div>
    );
  }
}

ManageAppointmentType = reduxForm({
  form: 'ManageAppointmentTypeform',
})(ManageAppointmentType);

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_APPOINTMENTTYPES_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_APPOINTMENTTYPES_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_APPOINTMENTTYPES_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_APPOINTMENTTYPES_LIST_DELETE')[0].permission : false;

  // End For Role Permission

  return {
    appointmentTypeListData: state.appointment_type.appointmentTypeList,
    deleted_AppointmentType: state.appointment_type.deleted_AppointmentType,
    saved_appointmentType: state.appointment_type.saved_appointmentType,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}

export default connect(mapStateToProps, { deleteAppointmentType, getAppointmentTypeList, getMasterData })(ManageAppointmentType);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/appointment-type/index.js